import { TicketDiscount } from "iconsax-react";
import styled from "styled-components";

import { LoadingOutlined } from "@ant-design/icons";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  border-bottom: 0.063rem solid
    ${({ theme }) => theme.checkoutStepsOffers?.widgetBackground};

  padding: 1rem 0;
`;

export const CuponContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  padding: 0.75rem 1rem;

  border-radius: 0.5rem;
  border: 0.125rem solid
    ${({ theme }) => theme.checkoutStepsOffers?.couponButtonBorder};
`;

export const HasCouponButton = styled.button`
  display: flex;
  align-items: center;

  width: 100%;

  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;

  border: none;
  cursor: pointer;
  background: transparent;
  color: ${({ theme }) => theme.checkoutStepsOffers?.widgetTextColor};
`;

export const TicketIcon = styled(TicketDiscount)`
  margin: 0 0.625rem 0 0;

  font-size: 1.5rem;
  color: ${({ theme }) => theme.checkoutStepsOffers?.widgetTextColor};
`;

export const Input = styled.input`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  width: 100%;
  height: 100%;
  padding: 0 0 0 1rem;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;

  border: none;
  border-radius: 0.5rem 0 0 0.5rem;
  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
  background: ${({ theme }) => theme.checkoutStepsOffers?.widgetBackground};
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;
  padding: 0 0.5rem;

  border: none;
  cursor: pointer;
  border-radius: 0 0.25rem 0.25rem 0;
  color: ${({ theme }) => theme.checkoutStepsOffers?.checkoutTextPrimary};
  background: ${(props) =>
    props.theme?.checkoutStepsOffers?.checkoutPrimaryColor};

  font-family: Inter;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5rem;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 3rem;
  margin: 1rem 0 0;

  border-radius: 0.5rem;
  border: 0.125rem solid transparent;
  box-shadow: 0px 0px 3rem rgba(0, 0, 0, 0.08);

  &:hover {
    transition: 300ms ease-in-out;
    border: 0.125rem solid
      ${({ theme }) => theme.checkoutStepsOffers?.checkoutPrimaryColor};
  }
`;

export const Discount = styled.span`
  margin: 0.5rem 0 0;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.checkoutStepsOffers?.green};
`;

export const LoadingIcon = styled(LoadingOutlined)`
  margin: 0 1rem 0 0;
`;
